/* eslint-disable no-undef */
(function () {
  angular.module('MktzapApp.Factories')
    .factory('NpsSurveyService', NpsSurveyService)

  NpsSurveyService.$inject = ['$resource']

  function NpsSurveyService ($resource) {
    return $resource(apiUrl + '/nps-survey', {}, {
      all: { method: 'GET', params: {}, isArray: false },
      update: { method: 'POST', params: {}, isArray: false }
    })
  }
// eslint-disable-next-line semi
})();
